import React, { forwardRef } from 'react';
import { Textarea } from '../Textarea/index.js';
import { FormControlLayout } from './FormControlLayout.js';
import { extractLayoutProps } from './utils.js';
export const FormControlTextarea = forwardRef((props, ref) => {
    const { layoutProps, inputProps } = extractLayoutProps(props);
    return (React.createElement(FormControlLayout, Object.assign({}, layoutProps),
        React.createElement(Textarea, Object.assign({ ref: ref }, inputProps))));
});
//# sourceMappingURL=FormControlTextarea.js.map